import Typography from "@mui/material/Typography";
import projectStore from "../store";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { ProjectInterface } from "../interfaces";


const CurrentProjectChip = observer(() => {
    const params = useParams();
    const currentProjectId = params.projectId ? +params.projectId : 0;
    const project: ProjectInterface | undefined = projectStore.getProjectById(currentProjectId);

    if (!project) return null;
    return (
        <>
            <Typography
                variant="body1"
                component="span"
                fontWeight={500}
                sx={{
                    pl: 3,
                }}
            >
                {project.title}
            </Typography>
        </>
    );
});


export default CurrentProjectChip;
